import { render, staticRenderFns } from "./AddDnsBatch.vue?vue&type=template&id=7e08a128&scoped=true"
import script from "./AddDnsBatch.vue?vue&type=script&lang=js"
export * from "./AddDnsBatch.vue?vue&type=script&lang=js"
import style0 from "./AddDnsBatch.vue?vue&type=style&index=0&id=7e08a128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e08a128",
  null
  
)

export default component.exports